import AccessibleTextLink from './component.jsx'

export default AccessibleTextLink
